import Layout from "global/component/Genericos/Layout/Layout";
import { GlobalContext } from "global/context/Provider";
import camelize from "global/utils/camelize";
import { useContext, useEffect, useState } from "react";
import InjectionIcon from "_+_Portal/assets/images/generico/InjectionIcon";
import LogoDim from "_+_Portal/assets/images/generico/LogoDim";
import MiTurnoIcon from "_+_Portal/assets/images/generico/MiTurnoIcon";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import { PortalContext } from "_+_Portal/context/Provider";
import BtnLink from "_+_Portal/_-_Autocheckin/components/genericos/BtnLink/BtnLink";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";

import {
  BtnContainerSelectorCircuito,
  ContianerSelectorCircuito,
  HeaderSelectorCircuitoBar,
} from "./localStyle";
import {
  setCircuito,
  setPaso,
} from "_+_Portal/_-_Autocheckin/context/action/paso";
import { OrderTurnos, OrderTurnosLabo } from "../PagesFun";
import { setTurnosSeleccionado } from "_+_Portal/_-_Autocheckin/context/action/turnosSeleccionados";
import { containerVariants, itemVariants } from "global/utils/btnTransition";
import { motion } from "framer-motion";
import { getLocalStorage } from "global/utils/safeJsonParse";

const SelectorCircuito = () => {
  //#region --------- context ---------------
  const {
    pasoDispatch,
    textosAutoCheckinState,
    turnosAutoCheckInState,
    turnosSeleccionadosDispatch,
  } = useContext(AutocheckContext);
  const { authState } = useContext(GlobalContext);
  const { selectDropDownState } = useContext(PortalContext);
  //#endregion  ----- context ---------------
  //#region  ----------- constants ---------------

  const [dataLoading, setDataLoading] = useState(true);
  const [laboPresent, setLaboPresent] = useState(false);
  const [turnoPresent, setTurnoPresent] = useState(false);
  const [laboPresentesList, setLaboPresentesList] = useState(false);

  const pacienteNombre = selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido?.paciente?.nombre
    ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente
        ?.nombre
    : authState?.auth?.data?.paciente?.nombre;

  const config = getLocalStorage("config", {});
  let opcAutoCheckInLabo = config?.opcAutoCheckInLabo;
  let idTerminal = getLocalStorage("idTerminal");
  let portal = config?.portal;

  const filtroHorario =
    textosAutoCheckinState.textosAutoCheckin?.data?.filtroHorario?.orden;
  const minutosToleranciaRecepcion =
    config?.minutosToleranciaRecepcion;
  const minRecepcionVariosTurnos = config?.minRecepcionVariosTurnos;
  //#endregion --------- constants ---------------

  //#region  ----------- funciones ---------------

  const volver = () => {
    setPaso("Home")(pasoDispatch);
  };

  const handleTurno = () => {
    if (turnoPresent) {
      setPaso("TurnosRecepcionadosQR")(pasoDispatch);
    } else {
      setPaso("TurnosDelDia")(pasoDispatch);
    }
  };

  const handleLaboratorio = () => {
    setCircuito("labo")(pasoDispatch);
    if (laboPresent) {
      setTurnosSeleccionado(laboPresentesList)(turnosSeleccionadosDispatch);
      setPaso("TurnosConPresente")(pasoDispatch);
    } else {
      setPaso("TurnosDelDiaLabo")(pasoDispatch);
    }
  };

  const checkTurnosPresentes = (data) => {
    if (data.length > 0) {
      const dataLabo = data.filter((turno) => turno.idProtocolo);
      const dataTurno = data.filter((turno) => turno.idProtocolo === 0);
      const laboOrdenados = OrderTurnosLabo(
        dataLabo,
        filtroHorario,
        minutosToleranciaRecepcion,
        minRecepcionVariosTurnos,
        true,
      );
      const turnosOrdenados = OrderTurnos(
        dataTurno,
        filtroHorario,
        minutosToleranciaRecepcion,
        minRecepcionVariosTurnos,
        false,
      );
      const turnosPresentes = turnosOrdenados.filter((turno) => turno.presente);
      const laboPresentes = laboOrdenados.filter(
        (turno) => turno.estadoProtocolo === 4 && turno.type === "laboratorio",
      );
      if (laboPresentes.length > 0) {
        setLaboPresentesList(laboPresentes);
        setLaboPresent(true);
      }
      if (turnosPresentes.length > 0) {
        setTurnoPresent(true);
      }
    }
    setDataLoading(false);
  };

  //#endregion --------- funciones ---------------
  //#region  ----------- useEffect ---------------
  useEffect(() => {
    checkTurnosPresentes(turnosAutoCheckInState.turnosAutoCheckIn.data);
  }, []);
  //#endregion  -------- useEffect ---------------

  return (
    <>
      <Loading
        dataLoading={dataLoading}
        color="c-white"
        descripcion={"Cargando..."}
      />

      {dataLoading ? (
        ""
      ) : (
        <Layout origen={"NULL"} positionSidebar={21}>
          <ContianerSelectorCircuito
            initial="hidden"
            animate="show"
            variants={containerVariants}
          >
            <HeaderSelectorCircuitoBar $isTerminal={idTerminal}>
              <div className="arrow" onClick={volver}>
                {"<"}
              </div>
              <span className="title">
                ¡Hola{" "}
                <span className="title-negrita">
                  {camelize(pacienteNombre)}
                </span>
                !{" "}
              </span>
              <span className="title-pregunta">
                ¿En que podemos ayudarte{" "}
                <span className="title-negrita">hoy</span>?
              </span>
            </HeaderSelectorCircuitoBar>
            <BtnContainerSelectorCircuito>
              <motion.div variants={itemVariants} style={{ width: "300px" }}>
                <BtnLink
                  Icon={<MiTurnoIcon color={"var(--color-primary)"} />}
                  type={turnoPresent ? "GREEN" : "NORMAL"}
                  title={
                    turnoPresent
                      ? "CONSULTA O PRACTICA PRESENTES"
                      : "CONSULTA O PRACTICA"
                  }
                  onclick={handleTurno}
                />
              </motion.div>
              {opcAutoCheckInLabo && (
                <motion.div variants={itemVariants} style={{ width: "300px" }}>
                  <BtnLink
                    Icon={<InjectionIcon color={"var(--color-primary)"} />}
                    type={laboPresent ? "GREEN" : "NORMAL"}
                    title={
                      laboPresent ? "LABORATORIO PRESENTES" : "LABORATORIO"
                    }
                    onclick={handleLaboratorio}
                  />
                </motion.div>
              )}
            </BtnContainerSelectorCircuito>
            {portal && portal === "dim" ? (
              <div className="logo-dim">
                <LogoDim height={"550"} />
              </div>
            ) : (
              ""
            )}
          </ContianerSelectorCircuito>
        </Layout>
      )}
    </>
  );
};

export default SelectorCircuito;
